export { default } from './Portal';
//# sourceMappingURL=index.js.map